/**
 * @module:  web3 页面汇总
 * @author: Shan
 * @date: 2023-05-10
 */

import { lazy } from 'react';
import { retry } from '@src/utils/tool';

// 沃客宇宙首页
export const UniverseHome = lazy(() => retry(() => import('@src/pages/Web3/UniverseHome')));
// 数字身份
export const DigitalIdentity = lazy(() => retry(() => import('@src/pages/Web3/DigitalIdentity')));
// 导入资产
export const ImportAssets = lazy(() => retry(() => import('@src/pages/Web3/ImportAssets')));
// 资产详情
export const AssetsDetail = lazy(() => retry(() => import('@src/pages/Web3/AssetsDetail')));
// 支付
export const Pay = lazy(() => retry(() => import('@src/pages/Web3/Pay')));
// 支付结果
export const PayResult = lazy(() => retry(() => import('@src/pages/Web3/Pay/result')));
// 预览
export const Preview = lazy(() => retry(() => import('@src/pages/Web3/Preview')));
